import { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTimeout from 'react-timeout';

class IntervalAction extends Component {
  componentDidMount() {
    const { action, duration, setInterval } = this.props;
    if (duration && action) {
      setInterval(action, duration);
    }
  }

  render() {
    return null;
  }
}

IntervalAction.propTypes = {
  duration: PropTypes.number.isRequired,
  action: PropTypes.func.isRequired,
  setInterval: PropTypes.func.isRequired,
};

export default ReactTimeout(IntervalAction);
